import cn from "classnames";

import { MonitoringPlanSlotTitle } from "@/components/monitoringPlanSlotTitle/monitoringPlanSlotTitle.component";
import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { truncatePortableTextAtFirstPeriod } from "@/utils/portableText.util";

import type { GetAdtPlusAppPageQueryResult } from "@/sanity.types";

import { PlanEyebrow } from "./planEyebrow.component";

export function FlexibleMonitoringAppPlanCard({
  plan,
}: {
  plan: FlexibleMonitoringAppPlanSlotData;
}) {
  return (
    <article
      className={cn(
        "flex h-full min-h-0 w-full max-w-87.5 min-w-0 shrink-0 flex-col overflow-hidden rounded-[28px] border border-white bg-white/50 md:w-full md:max-w-100",
        "backdrop-blur-md",
        "shadow-none md:shadow-[0_0_0_1px_rgba(0,34,106,0.045),0_24px_56px_-16px_rgba(7,64,139,0.11),0_10px_24px_-8px_rgba(7,64,139,0.07),inset_0_1px_0_0_#fff,inset_1px_0_0_0_rgba(255,255,255,0.88),inset_0_-1px_0_0_rgba(0,34,106,0.035),inset_-1px_0_0_0_rgba(0,34,106,0.025)]",
      )}>
      <div className="flex flex-1 flex-col gap-2 px-6 pt-8 pb-6 md:px-4 md:pt-6 md:pb-5 lg:px-6 lg:pt-8 lg:pb-6">
        <div className="flex flex-col gap-0 text-center">
          <PlanEyebrow plan={plan} />
          <MonitoringPlanSlotTitle
            title={plan.title}
            titleBold={plan.titleBold}
            titleRegular={plan.titleRegular}
            variant="h4"
            component="h3"
            className="text-greyscale-headline my-4 max-md:!text-[28px] md:!text-[32px] md:!leading-[1.15]"
          />
          {plan?.longDescription ? (
            <div className="text-greyscale-body [&_p]:text-greyscale-body mx-auto max-w-prose text-sm leading-relaxed sm:text-base">
              <RichText>
                {truncatePortableTextAtFirstPeriod(plan.longDescription)}
              </RichText>
            </div>
          ) : plan?.shortDescription ? (
            <Text
              variant="body1"
              component="p"
              className="text-greyscale-body mx-auto max-w-prose text-sm leading-relaxed sm:text-base">
              {plan.shortDescription}
            </Text>
          ) : null}
        </div>
      </div>
    </article>
  );
}

export type FlexibleMonitoringAppSectionBlock = Extract<
  NonNullable<NonNullable<GetAdtPlusAppPageQueryResult>["pageBuilder"]>[number],
  { _type: "flexibleMonitoringAppSection" }
>;

export type FlexibleMonitoringAppPlanSlotData = NonNullable<
  NonNullable<FlexibleMonitoringAppSectionBlock["plans"]>[number]
>;
